// Helpers injected into every generated workflow file so it runs standalone.
// IMPORTANT: keep these in sync with api/src/services/workflowExecutionService.js
//   - evaluateCondition           (~line 708)
//   - evaluateConditionRule       (~line 771)
//   - pickConditionItems          (~line 754)
// If you change condition operators or rule shape there, mirror it here.
var RUNTIME_HELPERS = [
  '// --- runtime helpers (auto-injected) ---',
  'function pickPath(value, path) {',
  '  if (value == null || !path) return value;',
  '  var parts = String(path).split(".").filter(Boolean);',
  '  var cur = value;',
  '  for (var i = 0; i < parts.length; i++) {',
  '    if (cur == null) return undefined;',
  '    cur = cur[parts[i]];',
  '  }',
  '  return cur;',
  '}',
  'function toComparableString(v) {',
  '  if (v == null) return "";',
  '  if (typeof v === "object") { try { return JSON.stringify(v); } catch (e) { return String(v); } }',
  '  return String(v);',
  '}',
  'function toNumber(v) { if (Array.isArray(v)) return v.length; var n = Number(v); return Number.isFinite(n) ? n : NaN; }',
  'function isBlankValue(v) { return v == null || (typeof v === "string" && v.trim() === ""); }',
  'function evaluateCondition(operator, expected, actual) {',
  '  var op = String(operator || "equals");',
  '  var L = toComparableString(actual), R = toComparableString(expected);',
  '  var Ln = toNumber(actual), Rn = toNumber(expected);',
  '  if (op === "equals") return L === R;',
  '  if (op === "not_equals") return L !== R;',
  '  if (op === "contains") return L.indexOf(R) >= 0;',
  '  if (op === "starts_with") return L.indexOf(R) === 0;',
  '  if (op === "ends_with") return R.length === 0 || L.slice(-R.length) === R;',
  '  if (op === "greater_than") return Number.isFinite(Ln) && Number.isFinite(Rn) && Ln > Rn;',
  '  if (op === "greater_or_equal") return Number.isFinite(Ln) && Number.isFinite(Rn) && Ln >= Rn;',
  '  if (op === "less_than") return Number.isFinite(Ln) && Number.isFinite(Rn) && Ln < Rn;',
  '  if (op === "less_or_equal") return Number.isFinite(Ln) && Number.isFinite(Rn) && Ln <= Rn;',
  '  if (op === "is_blank") return isBlankValue(actual);',
  '  if (op === "is_not_blank") return !isBlankValue(actual);',
  '  if (op === "regex") { try { return new RegExp(R).test(L); } catch (e) { return false; } }',
  '  return false;',
  '}',
  'function pickConditionItems(rule) {',
  '  if (!rule) return [];',
  '  if (Array.isArray(rule.conditions)) return rule.conditions.slice();',
  '  if (rule.root && Array.isArray(rule.root.items)) return rule.root.items;',
  '  return [];',
  '}',
  'function evaluateConditionRule(rule, inputValue, vars) {',
  '  var items = pickConditionItems(rule);',
  '  if (!items.length) return Boolean(inputValue);',
  '  var logic = String((rule && rule.logic) || (rule && rule.root && rule.root.logic) || "and").toLowerCase();',
  '  // Resolve @var references in the expected value.',
  '  function resolve(v) {',
  '    if (typeof v !== "string") return v;',
  '    return v.replace(/@(\\w+)/g, function(_, name) { return vars && name in vars ? vars[name] : ""; });',
  '  }',
  '  var fn = logic === "or" ? "some" : "every";',
  '  return items[fn](function(it) { return evaluateCondition(it.operator, resolve(it.value), inputValue); });',
  '}',
  '// --- end helpers ---'
].join('\n');

// Converts a workflow (nodes + connections) into a runnable Node.js source file.
// Mirrors the runtime contract from api/src/services/workflowExecutionService.js:
// each node's `code` defines `async function execute(inputs, settings, vars)`,
// receives the upstream output as `inputs`, the node's `paramValues` as `settings`,
// and a shared `vars` object for cross-node state.

function safeIdentifier(raw, fallback) {
  var base = String(raw == null ? '' : raw)
    .replace(/[^A-Za-z0-9_$]+/g, '_')
    .replace(/^[0-9]/, '_$&');
  if (!base) base = fallback || 'node';
  if (/^(do|if|in|for|let|new|try|var|case|else|enum|null|this|true|void|with|break|catch|class|const|false|super|throw|while|delete|export|import|return|switch|typeof|default|extends|finally|continue|debugger|function|instanceof)$/.test(base)) {
    base = base + '_';
  }
  return base;
}

function uniqueFnName(node, index, used) {
  var seed = node && (node.title || node.label || node.icon) || 'node';
  var name = 'run_' + safeIdentifier(seed, 'node_' + index);
  var candidate = name;
  var n = 2;
  while (used[candidate]) {
    candidate = name + '_' + n;
    n += 1;
  }
  used[candidate] = true;
  return candidate;
}

// In-memory uncompressed connections use { from, to }; compressed JSON uses
// { fromNodeId, toNodeId }. Read either so this works regardless of source.
function connFrom(c) { return c && (c.from != null ? c.from : c.fromNodeId); }
function connTo(c) { return c && (c.to != null ? c.to : c.toNodeId); }

// Mirrors api/src/services/workflowExecutionService.js#getConditionBranchAnchors
// (~line 1193). The "yes"/"no" anchors are derived from the condition node's
// incoming-connection toAnchor plus paramValues overrides
// (conditionYesAnchor, conditionBranchLayout, conditionBranchSwap).
// Keep this function in sync with the upstream source if anchor logic changes.
function pickDefaultAnchors(inputAnchor) {
  if (inputAnchor === 'top') return { yes: 'right', no: 'bottom' };
  if (inputAnchor === 'right') return { yes: 'bottom', no: 'left' };
  if (inputAnchor === 'bottom') return { yes: 'left', no: 'top' };
  if (inputAnchor === 'left') return { yes: 'top', no: 'right' };
  return { yes: 'top', no: 'bottom' };
}

function getConditionBranchAnchors(node, incomingConns) {
  var ANCHORS = ['top', 'right', 'bottom', 'left'];
  function isAnchor(v) { return ANCHORS.indexOf(v) >= 0; }
  var pv = (node && node.paramValues) || {};
  var layout = String(pv.conditionBranchLayout || '').trim().toLowerCase();
  var swap = String(pv.conditionBranchSwap || 'false') === 'true';
  var savedYes = String(pv.conditionYesAnchor || '').trim().toLowerCase();
  var savedNo = String(pv.conditionNoAnchor || '').trim().toLowerCase();

  var inputAnchor = null;
  if (Array.isArray(incomingConns) && incomingConns.length) {
    var ta = String(incomingConns[0].toAnchor || '').trim().toLowerCase();
    if (isAnchor(ta)) inputAnchor = ta;
  }
  var defaults = pickDefaultAnchors(inputAnchor);
  var state = { input: inputAnchor, yes: defaults.yes, no: defaults.no };

  if (layout === 'horizontal') state = { input: state.input, yes: 'right', no: 'left' };
  else if (layout === 'vertical') state = { input: state.input, yes: 'top', no: 'bottom' };
  else if (swap) state = { input: state.input, yes: 'right', no: 'left' };

  if (isAnchor(savedYes) && savedYes !== state.input) state.yes = savedYes;
  if (isAnchor(savedNo) && savedNo !== state.input) state.no = savedNo;

  if (!isAnchor(state.yes) || state.yes === state.input) state.yes = defaults.yes;
  if (!isAnchor(state.no) || state.no === state.input || state.no === state.yes) {
    state.no = defaults.no !== state.yes ? defaults.no : ANCHORS.find(function(a) {
      return a !== state.input && a !== state.yes;
    }) || null;
  }
  return state;
}

// Determine which branch ("yes" / "no") an outgoing connection from a condition
// node represents. Explicit `branch` wins; otherwise compare `fromAnchor`
// against the node's computed yes/no anchors.
function inferBranch(c, condNode, incomingToCond) {
  if (!c) return '';
  var explicit = String(c.branch || '').trim().toLowerCase();
  if (explicit === 'yes' || explicit === 'no') return explicit;
  var anchor = String(c.fromAnchor || '').trim().toLowerCase();
  if (!anchor) return '';
  var anchors = getConditionBranchAnchors(condNode, incomingToCond);
  if (anchor === anchors.yes) return 'yes';
  if (anchor === anchors.input) return ''; // input port — not a branch
  return 'no';
}

function topoOrder(nodes, connections) {
  var indexById = {};
  nodes.forEach(function(node, i) { if (node && node.id != null) indexById[node.id] = i; });

  var inDegree = nodes.map(function() { return 0; });
  var outgoing = nodes.map(function() { return []; });

  connections.forEach(function(c) {
    if (!c) return;
    var from = indexById[connFrom(c)];
    var to = indexById[connTo(c)];
    if (from == null || to == null) return;
    outgoing[from].push(to);
    inDegree[to] += 1;
  });

  var queue = [];
  nodes.forEach(function(node, i) {
    if (inDegree[i] === 0 && node && node.icon === 'start') queue.push(i);
  });
  nodes.forEach(function(node, i) {
    if (inDegree[i] === 0 && !(node && node.icon === 'start')) queue.push(i);
  });

  var order = [];
  var seen = {};
  while (queue.length) {
    var i = queue.shift();
    if (seen[i]) continue;
    seen[i] = true;
    order.push(i);
    outgoing[i].forEach(function(j) {
      inDegree[j] -= 1;
      if (inDegree[j] === 0) queue.push(j);
    });
  }
  nodes.forEach(function(_, i) { if (!seen[i]) order.push(i); });
  return order;
}

function indent(text, prefix) {
  return String(text || '')
    .split('\n')
    .map(function(line) { return line.length ? prefix + line : line; })
    .join('\n');
}

function describeNode(node) {
  var parts = [];
  if (node.title) parts.push('title: ' + node.title);
  if (node.icon) parts.push('type: ' + node.icon);
  if (node.subtitle) parts.push('subtitle: ' + node.subtitle);
  return parts.join(' | ');
}

function buildSettings(node) {
  // paramValues mirrors the runtime's `settings` argument.
  var paramValues = node && node.paramValues && typeof node.paramValues === 'object' ? node.paramValues : {};
  return JSON.stringify(paramValues, null, 2);
}

// Mirrors api/src/services/workflowExecutionService.js#parseVariableValue
function parseVariableValue(dataType, rawValue) {
  var type = String(dataType || '').toLowerCase();
  if (type === 'int' || type === 'integer' || type === 'number') {
    var n = Number(rawValue);
    return Number.isFinite(n) ? n : 0;
  }
  if (type === 'bool' || type === 'boolean') {
    if (typeof rawValue === 'boolean') return rawValue;
    var s = String(rawValue == null ? '' : rawValue).trim().toLowerCase();
    return s === 'true' || s === '1' || s === 'yes';
  }
  if (type === 'json' || type === 'object') {
    try { return JSON.parse(rawValue); } catch (e) { return {}; }
  }
  if (type === 'array') {
    try { var arr = JSON.parse(rawValue); return Array.isArray(arr) ? arr : []; } catch (e) { return []; }
  }
  return rawValue == null ? '' : String(rawValue);
}

function buildNodeFunction(node, fnName) {
  var header = '// ' + (describeNode(node) || 'node');
  var settingsJson = buildSettings(node);
  var hasUserCode = node && typeof node.code === 'string' && node.code.trim().length > 0;

  var body;
  if (hasUserCode) {
    // User code defines `async function execute(inputs, settings, vars)`.
    // We inline it, then invoke it with the node's paramValues as `settings`.
    var userCode = node.code.trim();
    body = userCode + '\n'
      + 'if (typeof execute !== "function") {\n'
      + '  throw new Error("Node \\"' + (node.title || node.icon || node.id) + '\\" must define async function execute(inputs, settings, vars)");\n'
      + '}\n'
      + 'return await execute(inputs, ' + settingsJson + ', vars);';
  } else if (node && node.icon === 'start') {
    body = '// Workflow entry point — passes the initial input through.\nreturn inputs[0];';
  } else if (node && node.icon === 'set-variable') {
    // Runtime contract: target var = paramValues.variable; if paramValues.source === "true",
    // value comes from upstream input, otherwise from paramValues.value. Mode controls
    // how the new value combines with the current one (replace=overwrite [default],
    // append=push onto a list / concat strings, merge=Object.assign for objects).
    body = '// Set-variable: writes into vars[settings.variable].\n'
      + 'const settings = ' + settingsJson + ';\n'
      + 'const targetName = String(settings.variable || "").trim();\n'
      + 'const fromInput = String(settings.source || "false") === "true";\n'
      + 'const mode = String(settings.mode || "replace").toLowerCase();\n'
      + 'let newValue = fromInput ? inputs[0] : settings.value;\n'
      + 'if (targetName && mode !== "replace") {\n'
      + '  const cur = vars[targetName];\n'
      + '  if (mode === "append") {\n'
      + '    if (Array.isArray(cur)) newValue = Array.isArray(newValue) ? cur.concat(newValue) : cur.concat([newValue]);\n'
      + '    else if (typeof cur === "string") newValue = cur + (newValue == null ? "" : String(newValue));\n'
      + '    else if (cur == null || cur === "") newValue = Array.isArray(newValue) ? newValue.slice() : [newValue];\n'
      + '  } else if (mode === "merge") {\n'
      + '    const curIsObj = cur && typeof cur === "object" && !Array.isArray(cur);\n'
      + '    const newIsObj = newValue && typeof newValue === "object" && !Array.isArray(newValue);\n'
      + '    if (curIsObj && newIsObj) newValue = Object.assign({}, cur, newValue);\n'
      + '    else if (newIsObj) newValue = Object.assign({}, newValue);\n'
      + '  }\n'
      + '}\n'
      + 'if (targetName) vars[targetName] = newValue;\n'
      + 'return newValue;';
  } else if (node && node.icon === 'condition') {
    // Condition: evaluate node.conditionRule against inputs[0]; return
    // { __branch: "yes"|"no", value: inputs[0] } so downstream guards see it.
    var ruleJson = JSON.stringify((node && node.conditionRule) || null, null, 2);
    body = 'const rule = ' + ruleJson + ';\n'
      + 'const passed = evaluateConditionRule(rule, inputs[0], vars);\n'
      + 'return { __branch: passed ? "yes" : "no", value: inputs[0] };';
  } else if (node && node.icon === 'variables') {
    // Runtime contract: variable name = node.title; output = parseVariableValue(dataType, value).
    var varName = String(node.title || '').trim();
    var dataType = (node.paramValues && node.paramValues.dataType) || 'string';
    var rawValue = node.paramValues ? node.paramValues.value : '';
    var parsed = parseVariableValue(dataType, rawValue);
    body = '// Variables node — registers `' + varName + '` and returns its value.\n'
      + 'const value = ' + JSON.stringify(parsed) + ';\n'
      + 'vars[' + JSON.stringify(varName) + '] = value;\n'
      + 'return value;';
  } else {
    body = '// TODO: implement "' + (node.title || node.icon || 'node') + '" — no code defined on this node.\n'
      + 'return inputs[0];';
  }

  return header + '\n'
    + 'async function ' + fnName + '(inputs, vars) {\n'
    + indent(body, '  ') + '\n'
    + '}\n';
}

// A guard "path" is a list of {condId, branch} pairs that must all hold for
// a node to run via that path. A node's guardPaths is a list of such paths;
// the node runs if any path is satisfied (OR of ANDs). Empty paths array =
// node is unreachable from start under any branching outcome (still emit
// unguarded — start nodes and disconnected nodes fall here). A path with
// zero entries = unguarded reach (always run).
function pathKey(path) {
  return path.map(function(g) { return g.condId + '=' + g.branch; }).sort().join('&');
}

function dedupePaths(paths) {
  var seen = {};
  var out = [];
  paths.forEach(function(p) {
    var k = pathKey(p);
    if (seen[k]) return;
    seen[k] = true;
    out.push(p);
  });
  return out;
}

// Walk in topological order. For each node:
//   - Each incoming connection contributes paths from its source node.
//   - If the source is a condition, append (condId, branch) to each contributed
//     path. (No branch label = pass through unchanged.)
//   - The node's paths are the union (deduped) across all incoming connections.
//   - If two incoming paths cover both branches of the same condition, that
//     condition is no longer a constraint — drop it from those paths so a
//     join point becomes unguarded for that condition.
function computeGuardPaths(nodes, connections, incoming, nodeById) {
  var order = topoOrder(nodes, connections);
  var pathsById = {};

  order.forEach(function(idx) {
    var node = nodes[idx];
    if (!node || node.id == null) return;
    var sources = incoming[node.id] || [];
    if (node.icon === 'start' || sources.length === 0) {
      pathsById[node.id] = [[]];
      return;
    }
    var contributed = [];
    sources.forEach(function(c) {
      var srcId = connFrom(c);
      var srcNode = nodeById[srcId];
      var srcPaths = pathsById[srcId] || [[]];
      if (srcNode && srcNode.icon === 'condition') {
        var incomingToCond = incoming[srcId] || [];
        var branch = inferBranch(c, srcNode, incomingToCond);
        if (branch) {
          srcPaths.forEach(function(p) {
            contributed.push(p.concat([{ condId: srcId, branch: branch }]));
          });
          return;
        }
      }
      srcPaths.forEach(function(p) { contributed.push(p.slice()); });
    });
    pathsById[node.id] = simplifyPaths(dedupePaths(contributed));
  });

  return pathsById;
}

// If two paths agree on every guard EXCEPT one condition where they take
// opposite branches, that condition is moot at this node — drop it and merge
// the two paths into one. Repeat until no more merges. Without this, a
// post-merge node would emit `(cond=yes && ...) || (cond=no && ...)` when it
// could just be `(...)`.
function simplifyPaths(paths) {
  var changed = true;
  var current = paths.slice();
  while (changed) {
    changed = false;
    outer: for (var i = 0; i < current.length; i++) {
      for (var j = i + 1; j < current.length; j++) {
        var merged = tryMergePaths(current[i], current[j]);
        if (merged) {
          current.splice(j, 1);
          current.splice(i, 1, merged);
          changed = true;
          break outer;
        }
      }
    }
  }
  return current;
}

function tryMergePaths(a, b) {
  var byCondA = {}, byCondB = {};
  a.forEach(function(g) { byCondA[g.condId] = g.branch; });
  b.forEach(function(g) { byCondB[g.condId] = g.branch; });
  var allConds = Object.keys(byCondA).concat(Object.keys(byCondB).filter(function(k) { return !(k in byCondA); }));
  var diffCond = null;
  for (var i = 0; i < allConds.length; i++) {
    var k = allConds[i];
    if (byCondA[k] !== byCondB[k]) {
      if (diffCond) return null; // more than one disagreement — can't merge
      if (byCondA[k] && byCondB[k]) diffCond = k; // both present, opposite branches
      else return null; // one side missing this guard — can't merge
    }
  }
  if (!diffCond) return a; // identical
  return a.filter(function(g) { return g.condId !== diffCond; });
}

function guardPathsToExpression(paths) {
  if (!paths || paths.length === 0) return '';
  // Any path with zero entries means "unguarded reach" — always run.
  if (paths.some(function(p) { return p.length === 0; })) return '';
  var clauses = paths.map(function(p) {
    var checks = p.map(function(g) {
      return 'conditionBranch[' + JSON.stringify(g.condId) + '] === ' + JSON.stringify(g.branch);
    });
    return checks.length === 1 ? checks[0] : '(' + checks.join(' && ') + ')';
  });
  return clauses.length === 1 ? clauses[0] : clauses.join(' || ');
}

function buildOrchestrator(nodes, connections, fnNamesByNodeId, order) {
  var indexById = {};
  var nodeById = {};
  nodes.forEach(function(node, i) {
    if (node && node.id != null) {
      indexById[node.id] = i;
      nodeById[node.id] = node;
    }
  });

  // Build per-target incoming-connection list (full conn objects, not just ids)
  // so we can honor propPath (e.g. ".message" pulls inputs[0].message).
  var incoming = {};
  connections.forEach(function(c) {
    if (!c) return;
    var fromId = connFrom(c);
    var toId = connTo(c);
    if (indexById[fromId] == null || indexById[toId] == null) return;
    if (!incoming[toId]) incoming[toId] = [];
    incoming[toId].push(c);
  });

  // Compute transitive branch guards. A node's guard is a list of "paths" from
  // any condition ancestor; each path is a conjunction of (condId, branch).
  // The node runs if ANY path's conjunction is satisfied. Without this, only
  // direct children of a condition are gated and indirect descendants run
  // unconditionally — leading to "Send Email (Events)" firing even when the
  // YES branch was skipped, etc.
  var guardPathsByNode = computeGuardPaths(nodes, connections, incoming, nodeById);

  // Seed vars from every `variables` node — they act like top-level state declarations.
  var varSeeds = [];
  nodes.forEach(function(node) {
    if (!node || node.icon !== 'variables') return;
    var name = String(node.title || '').trim();
    if (!name) return;
    var dataType = (node.paramValues && node.paramValues.dataType) || 'string';
    var rawValue = node.paramValues ? node.paramValues.value : '';
    var parsed = parseVariableValue(dataType, rawValue);
    varSeeds.push('    ' + JSON.stringify(name) + ': ' + JSON.stringify(parsed));
  });
  var varsLiteral = varSeeds.length
    ? '{\n' + varSeeds.join(',\n') + '\n  }'
    : '{}';

  var lines = [];
  lines.push('async function runWorkflow(initialInput) {');
  lines.push('  const vars = ' + varsLiteral + ';');
  lines.push('  const outputs = {};');
  lines.push('  const conditionBranch = {}; // condition-node id -> "yes"|"no"');
  lines.push('  let lastOutput;');
  lines.push('');

  order.forEach(function(idx) {
    var node = nodes[idx];
    if (!node) return;
    var fnName = fnNamesByNodeId[node.id];
    if (!fnName) return;
    var sources = incoming[node.id] || [];
    // Mirror runtime contract: `inputs` is always an array of upstream outputs,
    // honoring connection.propPath (e.g. ".message" extracts the message field).
    var inputExpr;
    if (node.icon === 'start' || sources.length === 0) {
      inputExpr = '[initialInput]';
    } else {
      var parts = sources.map(function(c) {
        var sid = connFrom(c);
        var srcNode = nodeById[sid];
        // Condition nodes wrap output as { __branch, value } — unwrap to value.
        var base = (srcNode && srcNode.icon === 'condition')
          ? '(outputs[' + JSON.stringify(sid) + '] && outputs[' + JSON.stringify(sid) + '].value)'
          : 'outputs[' + JSON.stringify(sid) + ']';
        var path = c && c.propPath ? String(c.propPath).trim() : '';
        if (!path) return base;
        var cleanPath = path.replace(/^\./, '');
        return 'pickPath(' + base + ', ' + JSON.stringify(cleanPath) + ')';
      });
      inputExpr = '[' + parts.join(', ') + ']';
    }

    // Build a guard expression from the precomputed transitive guard paths.
    // Multiple paths are OR'd; each path's checks are AND'd. An empty paths
    // array means "always run"; a path with zero checks also means "always
    // run" (unguarded reach).
    var guardExpr = guardPathsToExpression(guardPathsByNode[node.id]);

    lines.push('  // ' + (node.title || node.icon || node.id));
    if (guardExpr) {
      lines.push('  if (' + guardExpr + ') {');
      lines.push('    lastOutput = await ' + fnName + '(' + inputExpr + ', vars);');
      lines.push('    outputs[' + JSON.stringify(node.id) + '] = lastOutput;');
      lines.push('  }');
    } else {
      lines.push('  lastOutput = await ' + fnName + '(' + inputExpr + ', vars);');
      lines.push('  outputs[' + JSON.stringify(node.id) + '] = lastOutput;');
    }
    if (node.icon === 'condition') {
      // Capture which branch fired so downstream guards can read it.
      lines.push('  conditionBranch[' + JSON.stringify(node.id) + '] = lastOutput && lastOutput.__branch;');
    }
    lines.push('');
  });

  lines.push('  return lastOutput;');
  lines.push('}');
  return lines.join('\n');
}

function workflowToCode(workflowState) {
  var state = workflowState || {};
  var nodes = Array.isArray(state.nodes) ? state.nodes : [];
  var connections = Array.isArray(state.connections) ? state.connections : [];
  var workflowName = state.workflowName || 'Untitled Workflow';

  var fnNamesByNodeId = {};
  var usedNames = {};
  nodes.forEach(function(node, i) {
    if (!node || node.id == null) return;
    fnNamesByNodeId[node.id] = uniqueFnName(node, i, usedNames);
  });

  var order = topoOrder(nodes, connections);

  var header = '// Generated from workflow: ' + workflowName + '\n'
    + '// Generated at: ' + new Date().toISOString() + '\n'
    + '//\n'
    + '// Each node becomes one async function. The signature mirrors the AlleFlow\n'
    + '// runtime: each node defines `async function execute(inputs, settings, vars)`\n'
    + '// internally, where `inputs` is the upstream output, `settings` is the node\'s\n'
    + '// configured paramValues, and `vars` is a shared mutable map for cross-node state.\n'
    + '//\n'
    + '// Run with:  node ' + buildFileNameHint(workflowName) + '\n\n'
    + RUNTIME_HELPERS + '\n';

  var nodeFns = nodes
    .map(function(node) {
      if (!node || node.id == null) return '';
      return buildNodeFunction(node, fnNamesByNodeId[node.id]);
    })
    .filter(Boolean)
    .join('\n');

  var orchestrator = buildOrchestrator(nodes, connections, fnNamesByNodeId, order);

  var footer = '\n\nmodule.exports = { runWorkflow };\n\n'
    + 'if (require.main === module) {\n'
    + '  // Read initial input from argv[2] — try JSON first, fall back to raw string.\n'
    + '  let initialInput = {};\n'
    + '  if (process.argv[2] !== undefined) {\n'
    + '    try { initialInput = JSON.parse(process.argv[2]); }\n'
    + '    catch (e) { initialInput = process.argv[2]; }\n'
    + '  }\n'
    + '  runWorkflow(initialInput)\n'
    + '    .then(function(result) { console.log(JSON.stringify(result, null, 2)); })\n'
    + '    .catch(function(err) { console.error(err); process.exit(1); });\n'
    + '}\n';

  return header + nodeFns + '\n' + orchestrator + footer;
}

function buildFileNameHint(name) {
  return String(name || 'workflow').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '.js';
}

module.exports = { workflowToCode: workflowToCode, parseVariableValue: parseVariableValue };
